module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n.margin-top{\r\n    margin-top: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/organisation-profile/esi/esi-form/esi-form.component.css
// module id = ./src/app/hrms/payroll/organisation-profile/esi/esi-form/esi-form.component.css
// module chunks = main